import {
	Component,
	OnInit,
	Input,
	OnChanges,
	AfterViewInit,
	ChangeDetectorRef,
	Output,
	NgZone,
	EventEmitter
} from '@angular/core';
import { XlsFormSelectModelInterface } from '../../../models';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';

declare var $: any;
declare var Papa: any;

@Component({
	selector: 'app-select-instance',
	templateUrl: './select.instance.html'
})
export class SelectInstanceComponent implements OnInit, OnChanges, AfterViewInit {
	@Input() model: XlsFormSelectModelInterface;
	@Input() modelForm: FormGroup;
	@Input() selectComponents: any;
	@Input() isEdit: boolean;
	@Input() error: boolean;

	@Output() onEdit = new EventEmitter();
	@Output() onClose = new EventEmitter();
	@Output() onSubmit = new EventEmitter();

	@Output() onArray = new EventEmitter();

	choiceSource = new FormControl();
	choiceImport = new FormControl();
	choices: Array<any> = [];
	choiceError: boolean;
	isImport: any;

	constructor(private zone: NgZone, private ref: ChangeDetectorRef, private _fb: FormBuilder) {}

	ngOnChanges() {
		if (this.model && this.model.choices) {
			// console.log(this.model);
			this.choices = this.model.choices;
		}
		this.modelForm.patchValue(this.model);
	}

	initChoices() {
		// initialize our choices
		return this._fb.group({
			label: [ '' ],
			name: [ '' ]
		});
	}

	onCsv(r) {
		var files = r.srcElement.files;
		Papa.parse($('#id-input-file-2')[0].files[0], {
			header: true,
			skipEmptyLines: true,
			complete: (results) => {
				let result = results.data;
				for (let i = 0; i < result.length; i++) {
					this.choices.push({
						label: result[i].label,
						name: result[i].value.replace(/ /g, '_').toLowerCase()
					});
				}
				//this.payload = results;
				// console.log(results);
			}
		});
	}

	editChoice(choice, x) {
		let newlabel = choice.target.value;
		let obj = this.choices;
		let arrayFlatten;
		arrayFlatten = function(arr) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] === x) {
					arr[i].label = newlabel;
				}
			}
		};
		arrayFlatten(obj);
	}
	deleteChoice(choice, i) {
		let arr = this.choices;
		for (let x = 0; i < arr.length; x++) {
			let single = arr[x];
			if (choice.name == single.name) {
				// delete this.choices[x];2
				this.choices.splice(x, 1);
			}
		}
	}

	addChoice(val) {
		// console.log('about to add choices');
		this.choiceError = false;
		let choi = this.choices.filter((x) => x.name === val.replace(/ /g, '_').toLowerCase());
		if (choi.length > 0) {
			this.choiceError = true;
		} else {
			this.choices.push({ label: val, name: val.replace(/ /g, '_').toLowerCase() });
		}
	}

	removeChoice(i: number) {
		const control = <FormArray>this.modelForm.controls['choices'];
		control.removeAt(i);
	}

	choicesChange(evt) {
		if (evt === 'csv') {
			this.isImport = true;
		} else {
			this.isImport = false;
		}
	}

	calMethod(cal) {
		var $txt = $('#txtId');
		var caretPos = $txt[0].selectionStart;
		var textAreaTxt = $txt.val();
		var txtToAdd = `${cal}`;
		$txt.val(textAreaTxt.substring(0, caretPos) + txtToAdd + textAreaTxt.substring(caretPos));
	}

	fedMethod(fied) {
		let field = fied.target.value;
		var $txt = $('#txtId');
		var caretPos = $txt[0].selectionStart;
		var textAreaTxt = $txt.val();
		var txtToAdd = '${' + field + '}';
		$txt.val(textAreaTxt.substring(0, caretPos) + txtToAdd + textAreaTxt.substring(caretPos));
	}

	doSomething(evt) {
		// console.log('suppose to update view',evt)
		// this.zone.run(() => {
		if (evt) {
			let rel = evt.replace(/ /g, '_').toLowerCase();
			this.modelForm.patchValue({ name: rel.replace(/[^\w]/gi, '') });
			console.log(this.modelForm.value);
		}
		// })
	}
	continue() {
		this.isEdit == true ? this.edit() : this.save();
	}
	save() {
		this.modelForm.value.id = this.model.id;
		this.modelForm.value.type = this.model.type;
		this.modelForm.value.inputStyle = this.model.inputStyle;
		this.modelForm.value.control = this.model.control;
		this.modelForm.value.parentModel = this.model.parentModel;
		this.modelForm.value.choices = this.choices;
		let newModel: XlsFormSelectModelInterface;

		this.onSubmit.emit(Object.assign({}, newModel, this.modelForm.value));
	}

	edit() {
		// if a child of a group fi
		// if (this.model.parentModel !== '' && this.model.parentModel !== null && this.model.parentModel !== undefined) {
		//   this.model.name = `${this.model.parentModel}_${this.model.name}`
		// }
		// create a new copy bcos of funny behaviours
		let newModel = Object.assign({}, this.model);
		newModel.constraintGroup = this.modelForm.value.constraintGroup;
		newModel.relevantGroup = this.modelForm.value.relevantGroup;
		this.onEdit.emit(newModel);
	}

	ngOnInit() {
		// console.log(this.modelComponent)
	}
	ngAfterViewInit() {}
}
